import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfHeadline } from './sectionHelpers';

const ContactMap: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  const showMap = c.show_map !== false && c.show_map !== 'false';
  const mapUrl = (c.map_embed_url as string) || '';

  // hours can be an array of strings or a single string
  const hours: string[] = Array.isArray(c.hours)
    ? c.hours as string[]
    : c.hours
    ? [String(c.hours)]
    : [];

  return (
    <section className="sb-render sb-render-contact-map" style={{ padding: '80px 24px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ display: 'flex', gap: 48, alignItems: 'flex-start', flexWrap: 'wrap' }}>
          {/* Contact Info Column */}
          <div style={{ flex: 1, minWidth: 280 }}>
            <InlineEditText tag="h2" controlKey="headline" style={{ fontSize: '2.25rem', marginBottom: 24 }}>
              {sfHeadline(c, 'Get in Touch')}
            </InlineEditText>

            {c.business_name && (
              <p style={{ fontSize: '1.125rem', fontWeight: 600, marginBottom: 12 }}>{c.business_name}</p>
            )}

            {c.address && (
              <p style={{ color: '#64748b', marginBottom: 12, lineHeight: 1.6, whiteSpace: 'pre-line' }}>
                {c.address}
              </p>
            )}

            {c.phone && (
              <p style={{ marginBottom: 6 }}>
                <a href={`tel:${c.phone}`} style={{ color: 'var(--brand-primary, #2563eb)', textDecoration: 'none', fontWeight: 500 }}>
                  {c.phone}
                </a>
              </p>
            )}

            {c.email && (
              <p style={{ marginBottom: 12 }}>
                <a href={`mailto:${c.email}`} style={{ color: 'var(--brand-primary, #2563eb)', textDecoration: 'none', fontWeight: 500 }}>
                  {c.email}
                </a>
              </p>
            )}

            {hours.length > 0 && (
              <div style={{ marginTop: 16 }}>
                <h4 style={{ fontSize: '0.875rem', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#94a3b8', marginBottom: 8 }}>
                  Opening Hours
                </h4>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {hours.map((h, i) => (
                    <li key={i} style={{ fontSize: '0.9rem', color: '#64748b', marginBottom: 4 }}>{h}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>

          {/* Map Column */}
          {showMap && mapUrl && (
            <div style={{ flex: 1, minWidth: 320, borderRadius: 'var(--brand-card-radius, 12px)', overflow: 'hidden' }}>
              <iframe
                src={mapUrl}
                width="100%"
                height="360"
                style={{ border: 0, display: 'block' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Location map"
              />
            </div>
          )}

          {showMap && !mapUrl && (
            <div style={{
              flex: 1, minWidth: 320, height: 360,
              borderRadius: 'var(--brand-card-radius, 12px)',
              background: '#f1f5f9', display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              color: '#94a3b8', fontSize: '0.875rem',
            }}>
              Map embed URL not set
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ContactMap;
